var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGridType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    fillRule: "evenodd",
    d: "M2.833.542A2.292 2.292 0 0 0 .54 2.834V4.5a2.292 2.292 0 0 0 2.292 2.292h3.333A2.292 2.292 0 0 0 8.458 4.5V2.834A2.292 2.292 0 0 0 6.166.542H2.833ZM1.79 2.834c0-.576.466-1.042 1.042-1.042h3.333c.575 0 1.042.466 1.042 1.042V4.5c0 .576-.467 1.042-1.042 1.042H2.833A1.042 1.042 0 0 1 1.79 4.5V2.834Zm1.042 5.208A2.292 2.292 0 0 0 .54 10.334v5.833a2.292 2.292 0 0 0 2.292 2.292h3.333a2.292 2.292 0 0 0 2.292-2.292v-5.833a2.292 2.292 0 0 0-2.292-2.292H2.833ZM1.79 10.334c0-.576.466-1.042 1.042-1.042h3.333c.575 0 1.042.466 1.042 1.042v5.833c0 .575-.467 1.042-1.042 1.042H2.833a1.042 1.042 0 0 1-1.042-1.042v-5.833Zm8.75 4.166a2.292 2.292 0 0 1 2.292-2.291h3.333a2.292 2.292 0 0 1 2.292 2.291v1.667a2.292 2.292 0 0 1-2.292 2.292h-3.333a2.292 2.292 0 0 1-2.292-2.292V14.5Zm2.292-1.041c-.576 0-1.042.466-1.042 1.041v1.667c0 .575.466 1.042 1.042 1.042h3.333c.575 0 1.042-.467 1.042-1.042V14.5c0-.575-.467-1.041-1.042-1.041h-3.333Zm0-12.917a2.292 2.292 0 0 0-2.292 2.292v5.833a2.292 2.292 0 0 0 2.292 2.292h3.333a2.292 2.292 0 0 0 2.292-2.292V2.834A2.292 2.292 0 0 0 16.166.542h-3.333ZM11.79 2.834c0-.576.466-1.042 1.042-1.042h3.333c.575 0 1.042.466 1.042 1.042v5.833c0 .575-.467 1.042-1.042 1.042h-3.333a1.042 1.042 0 0 1-1.042-1.042V2.834Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridType2);
export default __webpack_public_path__ + "static/media/grid-type-2.8f89b4d027ffc1748b6f9ad07f44023e.svg";
export { ForwardRef as ReactComponent };